// extracted by mini-css-extract-plugin
module.exports = {"ConfirmEmail":"ConfirmEmail_ConfirmEmail__1NJ3j","title":"ConfirmEmail_title__2Psn8"};